import { createFileRoute } from "@tanstack/react-router";
import { OperatorsPage } from "../features/operators/pages/operators-page";

export const Route = createFileRoute("/operators")({
  component: OperatorsPage,
});
